<script lang="ts">
    import Wheel from "../../svg/Wheel.svelte";
</script>

<Wheel width="40px" height="40px" />
<span class="title"> Craft Roulette </span>

<style>
.title {
  color: var(--title);
  padding-left: 1rem;
  display: inline-flex;
  gap: 0.15rem;
}
</style>
